import paths from 'shared/paths';
import { FooterLink, FooterText, FooterWrapper } from './Footer.styled';

export const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <FooterWrapper>
            <FooterText>
                © {year} <b>Codahead</b>. All rights reserved
            </FooterText>
        </FooterWrapper>
    );
};
